export default () => ({
  articles: null,
})
